import React from 'react';
import { Sun, Moon } from 'lucide-react';
import { useTheme } from './ThemeContext';
export function ThemeToggle() {
  const {
    theme,
    toggleTheme
  } = useTheme();
  return <button onClick={toggleTheme} className="p-2 rounded-lg hover:bg-white/5 dark:hover:bg-white/5 transition-colors text-slate-600 dark:text-[#a3a3a3] hover:text-slate-900 dark:hover:text-white" aria-label="Toggle theme" data-id="element-262">
      {theme === 'light' ? <Moon size={20} data-id="element-263" /> : <Sun size={20} data-id="element-264" />}
    </button>;
}